import { render } from "./GraphicDesign.vue?vue&type=template&id=68fd8b3d&scoped=true"
import script from "./GraphicDesign.vue?vue&type=script&lang=js"
export * from "./GraphicDesign.vue?vue&type=script&lang=js"

import "./GraphicDesign.vue?vue&type=style&index=0&id=68fd8b3d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fd8b3d"]])

export default __exports__